<div class="modal-content">
  <!-- <div class="modal-header">
      <h5 class="modal-title">Select Site</h5>        
    </div> -->

  <div class="modal-body" #basicModal>
    <div class="row" class="main-form">
      <div class="">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="form-group">
              <h5 class="pl160">{{ConformationText}}</h5> <br>
              <h5 class="text-center">{{Title}}</h5>
            </div>
          </div>

        </div>
      </div>

    </div>
    <!-- </form> -->
  </div>
  <div class="modal-footer justify-content-center">
    <div class="m-0 row justify-content-center">
      <div class="col-md-3 col-sm-12">
        <button type="submit" (click)="DeleteandlockEmbd()" class="btn btn-default btn-action me-0 ">
          <svg class="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path id="_5402431_done_success_tick_valid_approve_icon_1_"
              data-name="5402431_done_success_tick_valid_approve_icon (1)"
              d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4.71,7.71-5,5a1,1,0,0,1-1.42,0l-2-2a1,1,0,0,1,1.42-1.42L11,12.59l4.29-4.3a1,1,0,1,1,1.42,1.42Z"
              transform="translate(-2 -2)" fill="#fff" />
          </svg>
          <p>Yes</p>
        </button>
      </div>
      <div class="col-md-3 col-sm-12">
        <button type="submit" (click)="close()" class="btn btn-default btn-action me-0">
          <svg class="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path id="_5402431_done_success_tick_valid_approve_icon_1_"
              data-name="5402431_done_success_tick_valid_approve_icon (1)"
              d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm4.71,7.71-5,5a1,1,0,0,1-1.42,0l-2-2a1,1,0,0,1,1.42-1.42L11,12.59l4.29-4.3a1,1,0,1,1,1.42,1.42Z"
              transform="translate(-2 -2)" fill="#fff" />
          </svg>
          <p>No</p>
          <!-- <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon> -->
        </button>
      </div>
    </div>
  </div>
</div>
